import React from 'react';
import { Box, Container, Heading, Flex, Image, SimpleGrid } from '@chakra-ui/react';
import lightsparkLogo from './logos/lightspark.jpg';
import ucsbLogo from './logos/ucsb.png';
import mystenLogo from './logos/mysten.jpg';
import riceLogo from './logos/rice.jpg';
import flashbotsLogo from './logos/flashbots.svg';
import consensysLogo from './logos/consensys.jpeg';
import nubitLogo from './logos/nubit.png';
import cbsLogo from './logos/cbs.png';
import roycoLogo from './logos/royco.jpg';
import chainlinkLogo from './logos/chainlink.png';
import uniswapLogo from './uf_logo.png';
// import falconxLogo from './logos/falconx.png';
import eigenLogo from './logos/eigen.png';
import chaincodeLogo from './logos/chaincode.png';
import osmosisLogo from './logos/osmosis.jpg';

const logos = [
  { src: ucsbLogo, alt: 'Logo 1' },
  { src: chaincodeLogo, alt: 'Logo 2' },
  { src: consensysLogo, alt: 'Logo 3' }, // Add more logos as needed
  { src: lightsparkLogo, alt: 'Logo 4' },
  { src: riceLogo, alt: 'Logo 5' },
  { src: flashbotsLogo, alt: 'Logo 6' },
  { src: uniswapLogo, alt: 'Logo 7' },
  { src: nubitLogo, alt: 'Logo 9' },
  { src: cbsLogo, alt: 'Logo 10' },
  { src: roycoLogo, alt: 'Logo 11' },
  { src: mystenLogo, alt: 'Logo 12' },
  { src: eigenLogo, alt: 'Logo 13' },
  { src: osmosisLogo, alt: 'Logo 14' },
  { src: chainlinkLogo, alt: 'Logo 14' },
];

const Logos = () => (
  <Box py={12} bg="blue.50">
    <Container maxW="7xl">
      <Heading
        as="h2"
        size="lg"
        mb={8}
        color="blue.700"
        fontWeight="extrabold"
        letterSpacing="tight"
        textAlign="left"
      >
        Our Speakers Come From
      </Heading>
      <SimpleGrid columns={{ base: 2, sm: 3, md: 5 }} spacing={8}>
        {logos.map((logo, idx) => (
          <Flex
            key={idx}
            align="center"
            justify="center"
            bg="white"
            borderRadius="xl"
            boxShadow="md"
            p={4}
            transition="all 0.2s"
            _hover={{
              boxShadow: "xl",
              transform: "scale(1.07)",
              bg: "blue.50",
            }}
            minH="90px"
          >
            <Image
              src={logo.src}
              alt={logo.alt}
              maxH="60px"
              maxW="120px"
              objectFit="contain"
              filter="grayscale(0%)"
              transition="filter 0.2s"
              _hover={{ filter: "grayscale(0%)" }}
            />
          </Flex>
        ))}
      </SimpleGrid>
    </Container>
  </Box>
);

export default Logos;
